import styled from 'styled-components';
import { media } from 'src/ui/common/mixins/media';

export const StyledWrapper = styled.div`
  min-width: 172px;
  border-radius: 5px;
  background-color: ${({ theme }) => theme.colors.gs500};

  ${media.md`
    min-width: 220px;
  `}
`;

export const StyledInfo = styled.div`
  padding: 20px 15px 15px;
  
  ${media.sm`
    padding: 20px;
  `}
`;

export const StyledCreatorName = styled.div`
  width: 92px;
  height: 10px;
  background: ${({ theme }) => theme.colors.gs400};
  border-radius: 2px;
`;

export const StyledName = styled.div`
  margin-top: 5px;
  width: 122px;
  height: 15px;
  background: ${({ theme }) => theme.colors.gs400};
  border-radius: 2px;

  ${media.sm`
    margin-top: 7px;
    width: 142px;
  `};
`;

export const StyledPrices = styled.div`
  margin-top: 10px;
  width: 140px;
  height: 10px;
  background: ${({ theme }) => theme.colors.gs400};
  border-radius: 2px;

  ${media.sm`
    width: 170px;
  `};
`;
